import { render, staticRenderFns } from "./ProvideBattleRoyaleResults.vue?vue&type=template&id=25490010&"
import script from "./ProvideBattleRoyaleResults.vue?vue&type=script&lang=js&"
export * from "./ProvideBattleRoyaleResults.vue?vue&type=script&lang=js&"
import style0 from "./ProvideBattleRoyaleResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports